export default [
  {
    key: 'planName',
    title: '计划名称',
    fixed: 'left',
    width: 106,
    overflow: true
  },
  {
    key: 'imageDetailNames',
    title: '素材',
    width: 108,
    overflow: true
  },
  {
    key: 'mediaName',
    title: '媒体',
    width: 80,
    overflow: true
  },
  {
    key: 'accountName',
    title: '账号',
    width: 100
  },
  {
    key: 'createOpName',
    title: '计划新建人员',
    overflow: true
  },
  {
    key: 'opType',
    title: '操作类型'
  },
  {
    key: 'isSuccess',
    title: '状态'
  },
  {
    key: 'createTime',
    title: '创建时间',
    width: 80
  },
  {
    key: 'upTime',
    title: '最后修改时间',
    width: 80
  },
  {
    key: 'lastOpName',
    title: '最后操作人',
    width: 60
  },
  {
    key: 'control',
    title: '操作',
    width: 52
  }
]
